import { initializeApp } from "firebase/app";
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  ConfirmationResult,
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  sendEmailVerification as firebaseSendEmailVerification,
  linkWithCredential,
  EmailAuthProvider,
  PhoneAuthProvider,
  UserCredential,
  User,
} from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBTLP40xqHFP0OClNc8q14RyN_Am6M9jTU",
  authDomain: "vr-rental-store.firebaseapp.com",
  projectId: "vr-rental-store",
  storageBucket: "vr-rental-store.firebasestorage.app",
  messagingSenderId: "470096275839",
  appId: "1:470096275839:web:e473db097ad96d3efad24a",
  measurementId: "G-J8CHP3JRZN"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

// ── Phone OTP (existing) ──────────────────────────────────

export function setupRecaptcha(elementId: string): RecaptchaVerifier {
  const verifier = new RecaptchaVerifier(auth, elementId, {
    size: "invisible",
    callback: () => {},
  });
  return verifier;
}

export async function sendOtp(
  phoneNumber: string,
  recaptchaVerifier: RecaptchaVerifier
): Promise<ConfirmationResult> {
  const formattedPhone = phoneNumber.startsWith("+") ? phoneNumber : `+91${phoneNumber}`;
  return signInWithPhoneNumber(auth, formattedPhone, recaptchaVerifier);
}

// ── Google Sign-In ────────────────────────────────────────

const googleProvider = new GoogleAuthProvider();

export async function signInWithGoogle(): Promise<UserCredential> {
  return signInWithPopup(auth, googleProvider);
}

// ── Email / Password ──────────────────────────────────────

export async function signUpWithEmail(email: string, password: string): Promise<UserCredential> {
  return createUserWithEmailAndPassword(auth, email, password);
}

export async function signInWithEmail(email: string, password: string): Promise<UserCredential> {
  return signInWithEmailAndPassword(auth, email, password);
}

export async function sendPasswordReset(email: string): Promise<void> {
  return firebaseSendPasswordResetEmail(auth, email);
}

// ── Account Linking helpers ───────────────────────────────

export { linkWithCredential, EmailAuthProvider, PhoneAuthProvider };

// ── Email Verification ────────────────────────────────────

export async function sendEmailVerification(user: User): Promise<void> {
  return firebaseSendEmailVerification(user);
}

// ── ID Token for API calls ────────────────────────────────

export async function getIdToken(): Promise<string | null> {
  const currentUser = auth.currentUser;
  if (!currentUser) return null;
  return currentUser.getIdToken();
}

// ── ID Proof Upload ───────────────────────────────────────

export async function uploadIdProof(file: File, uid: string): Promise<string> {
  const ext = file.name.split(".").pop() || "dat";
  const path = `idProofs/${uid}/${Date.now()}.${ext}`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file, { contentType: file.type });
  return getDownloadURL(fileRef);
}

// ── Sync user to database ─────────────────────────────────

export async function syncUserToDb(user: User, extraData: Record<string, string> = {}): Promise<void> {
  try {
    const token = await user.getIdToken();
    await fetch("/.netlify/functions/sync-user", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(extraData),
    });
  } catch (err) {
    console.warn("Failed to sync user to DB:", err);
  }
}

export default app;
